import { TutorialStep } from 'src/replicant/buruburu/tutorial/tutorial.ruleset';
import platform, { analytics } from '@play-co/gcinstant';
import { openPopupPromise } from '../../lib/popups/popupOpenClose';
import { isPlatformGuest } from '../../lib/utils';

type TutorialAnalytics = {
  $stepIndex: number;
  $stepName: string;
};

export async function showTutorial(
  step: TutorialStep,
  analyticsProps: TutorialAnalytics,
) {
  analytics.pushEvent('TutorialStepStart', analyticsProps);
  await openPopupPromise('popupTutorialStep', { step });
  await openPopupPromise('popupTutorialReward', {
    step,
  });
  analytics.pushEvent('TutorialStepFinish', analyticsProps);

  if (isPlatformGuest(platform)) {
    await openPopupPromise('popupNativeLineGuestLogin', { origin: 'sequence' });
  }
}
